import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContentFirst() {
    const navigate = useNavigate();

    return (
        <div className="container-fluid py-4">
            <div className="row">
                {/* Profile Card */}
                <div className="col-xl-6 col-md-6 mb-4">
                    <div 
                        className="card border-left-success shadow h-100 py-3"
                        onClick={() => navigate('/profile_edit')}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            borderRadius: '16px',
                            borderLeftWidth: '5px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)';
                        }}
                    >
                        <div className="card-body d-flex align-items-center justify-content-between px-4">
                            <div style={{ textAlign: 'left' }}>
                                <div className="text-xs font-weight-bold text-success text-uppercase mb-1">
                                    Member Profile
                                </div>
                                <h5 className="mb-0 font-weight-bold text-gray-800">
                                    Manage Profile & Representatives
                                </h5>
                                <span className="text-xs text-muted">Click to view/update profile</span>
                            </div>
                            <div className="icon-circle bg-success text-white p-3 rounded-circle shadow-sm">
                                <i className="fas fa-user fa-2x"></i>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Change Password Card */}
                <div className="col-xl-6 col-md-6 mb-4">
                    <div 
                        className="card border-left-info shadow h-100 py-3"
                        onClick={() => navigate('/change-member-password')}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            borderRadius: '16px',
                            borderLeftWidth: '5px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.15)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15)';
                        }}
                    >
                        <div className="card-body d-flex align-items-center justify-content-between px-4">
                            <div style={{ textAlign: 'left' }}>
                                <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                                    Security Settings
                                </div>
                                <h5 className="mb-0 font-weight-bold text-gray-800">
                                    Change Login Password
                                </h5>
                                <span className="text-xs text-muted">Keep your account secure</span>
                            </div>
                            <div className="icon-circle bg-info text-white p-3 rounded-circle shadow-sm">
                                <i className="fas fa-key fa-2x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
        </div>
    );
}
